import Details from './Details.container'
export default Details
